import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { perpsV1SectorsDataProvider } from './dataProvider';

// 注册 perps-v1-sectors 模块的数据提供者
export function initPerpsV1SectorsDataProvider() {
  registerModuleDataProvider(Resources.perpsV1Sectors, perpsV1SectorsDataProvider);
}

// 自动初始化
initPerpsV1SectorsDataProvider();
